module.exports = __webpack_public_path__ + "brian_logsdon_tech.png";